import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { SiteDocsUrl, Language } from 'app/shared/model/enums';

@Component({
  selector: 'app-refund-cancellation-policy',
  templateUrl: './refund-cancellation-policy.component.html',
  styleUrl: './refund-cancellation-policy.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
    
})
export class RefundCancellationPolicyComponent implements OnInit{
 pdfSrc:string
  language:Language
  docType:SiteDocsUrl;
  
  constructor(private route: ActivatedRoute,private _service:SubscriptionService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
       this.language = params['language'] || null;
    });
   if(this.language==Language.he)
     this.docType=SiteDocsUrl.RefundCancellationPolicyHebrew
    else 
    this.docType=SiteDocsUrl.RefundCancellationPolicyEnglish
  
    this._service.getSiteDocUrl(this.docType).subscribe(
      succ=>{
        this.pdfSrc=succ
        this.cdr.markForCheck()
      }
    )
  }
}
